<template>
  <div class="city-selector-container">
    <div class="city-selector-inner">
      <div class="text-center mb-4">
        <img
          src="@/core/assets/images/layout/logo-admin-transparent.png"
          alt="TravelCab"
          class="selector-logo mb-3"
        />
        <h1 class="selector-title">TravelCab</h1>
        <p class="selector-subtitle">
          Selecciona una ciudad para operar o entra a la administración global
        </p>
      </div>

      <div class="cards-grid">
        <!-- Card de Administración (global) -->
        <button type="button" class="selector-card selector-card--admin" @click="goToAdmin()">
          <span class="card-icon">
            <i class="ri-settings-3-line"></i>
          </span>
          <span class="card-title">Administración</span>
          <span class="card-subtitle">Configuración global</span>
        </button>

        <!-- Una card por ciudad activa -->
        <button
          v-for="city in cities"
          :key="city.id"
          type="button"
          class="selector-card"
          @click="goToCity(city)"
        >
          <span class="card-icon">
            <i class="ri-map-pin-line"></i>
          </span>
          <span class="card-title">{{ city.name }}</span>
          <span class="card-subtitle">{{ city.country_name }}</span>
        </button>
      </div>

      <p v-if="loaded && !cities.length" class="text-center text-muted mt-4">
        No hay ciudades activas registradas.
      </p>

      <div class="text-center mt-4">
        <button type="button" class="logout-link" @click="logout()">
          <i class="ri-logout-box-r-line mr-1"></i> Cerrar sesión
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Alert } from "wize-admin";
import { ADMIN_HOME_ROUTE, CITY_HOME_ROUTE } from "@/core/utils/menus";

export default {
  name: "CitySelectorPage",
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    ...mapGetters({
      cities: "city/getCities",
    }),
  },
  methods: {
    async goToCity(city) {
      await this.$store.dispatch("city/selectCity", city);
      this.$router.push({ name: CITY_HOME_ROUTE });
    },
    async goToAdmin() {
      await this.$store.dispatch("city/selectAdminLevel");
      this.$router.push({ name: ADMIN_HOME_ROUTE });
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch("app/loading", true);
      await this.$store.dispatch("city/loadCities");
    } catch (e) {
      console.error(e);
      Alert.error(e?.errors?.message || "Error al cargar las ciudades");
    } finally {
      this.loaded = true;
      await this.$store.dispatch("app/loading", false);
    }
  },
};
</script>

<style scoped lang="stylus">
.city-selector-container
  min-height: 100vh
  display: flex
  align-items: center
  justify-content: center
  background: #1b1f3b
  padding: 32px 16px

.city-selector-inner
  width: 100%
  max-width: 900px

.selector-logo
  max-width: 56px

.selector-title
  color: #fff
  font-size: 28px
  font-weight: 700
  margin-bottom: 4px

.selector-subtitle
  color: rgba(255, 255, 255, 0.7)
  font-size: 14px
  margin-bottom: 0

.cards-grid
  display: grid
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr))
  gap: 20px

.selector-card
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  padding: 28px 16px
  background: #fff
  border: 2px solid transparent
  border-radius: 12px
  cursor: pointer
  transition: transform 0.15s ease, border-color 0.15s ease
  &:hover
    transform: translateY(-3px)
    border-color: #4a5ee0

.selector-card--admin
  background: #f4f6ff

.card-icon
  font-size: 32px
  color: #4a5ee0
  line-height: 1
  margin-bottom: 12px

.card-title
  font-size: 16px
  font-weight: 600
  color: #1b1f3b

.card-subtitle
  font-size: 12px
  color: #7a7f9a
  margin-top: 2px

.logout-link
  background: transparent
  border: 0
  color: rgba(255, 255, 255, 0.7)
  font-size: 13px
  &:hover
    color: #fff
</style>
